import { App } from 'vue';
import vTipDirective from './src/tip.ts';
declare const _default: {
    install: (app: App) => void;
};
export default _default;
export { vTipDirective as vTip };
